<template>
    <div class="vh-100 d-flex flex-row align-items-center justify-content-center">
        <div class="card text-center border-0 bg-orange p-5">
            <div class="fs-2 fw-bold text-white">
                Transport Log System
            </div>
            <div class="text-center mt-5">
                <Logo class="justify-content-center" />
            </div>

        </div>
    </div>
</template>

<script>

import CleanLayout from "../Layouts/CleanLayout.vue";
import Logo from "../components/Logo.vue";

export default {
    name: "Index",
    layout: CleanLayout,
    components: {
        Logo
    }
}
</script>

<style scoped>
.card {
    width: 100%;
    max-width: 25rem;
}
</style>
